import { render, staticRenderFns } from "./commonEditWord.vue?vue&type=template&id=a44333ee&"
import script from "./commonEditWord.vue?vue&type=script&lang=js&"
export * from "./commonEditWord.vue?vue&type=script&lang=js&"
import style0 from "./commonEditWord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports